export enum LogsPaths {
  commandLog = 'command-log',
  adminLog = 'admin-log',
  eventLog = 'event-log',
  setValueLog = 'setvalue-log',
  userActivityLog = 'useractivity-log',
  notifyLog = 'notify-log',
  businessParamFailureLog = 'business-param-failure-log'
}
